module.exports = {"511802001":"东城街道","511802002":"西城街道","511802003":"河北街道","511802004":"青江街道","511802100":"北郊镇","511802101":"草坝镇","511802102":"合江镇","511802103":"大兴镇","511802104":"对岩镇","511802105":"沙坪镇","511802106":"中里镇","511802107":"上里镇","511802108":"严桥镇","511802109":"晏场镇","511802110":"多营镇","511802111":"碧峰峡镇","511802200":"南郊乡","511802201":"八步乡","511802202":"观化乡","511802203":"孔坪乡","511802204":"凤鸣乡","511802205":"望鱼乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511802.json
// module id = 2380
// module chunks = 0